export const SEARCH_TYPE = 'quick-shop';
